// https://sistemas.ucasal.edu.ar/sagbackend/api/v1/terminos_y_condiciones/inscripcion/obtener_notificacion?lugar=${id_lugar}&sector=${id_sector}&carrera=${id_carrera}&modo=${id_modo}&idTipoNotif=1

import { SERVICES_URL } from "../../config/config";
import generateTokenService from "../auth/generate-token";


const getNotificationCheckbox = async ({ token, callbacks, params }) => {
    //const response = await connection({ method: 'GET', url: `${SERVICES_URL.CHECKBOXES.NOTIFICATION}`, token, params });

    let currentToken = token;

    if (!currentToken) {
        currentToken = await new Promise((resolve, reject) => {
            generateTokenService({
                callbacks: (response) => {
                    if (response.success) {
                        resolve(response.data.token);
                    } else {
                        reject(response);
                    }
                },
            });
        });
    }

    const res = await fetch(SERVICES_URL.CHECKBOXES.NOTIFICATION + '?lugar=' + params.lugar + '&sector=' + params.sector + '&carrera=' + params.carrera + '&modo=' + params.modo + '&idTipoNotif=' + params.idTipoNotif, {
        headers: {
            'auth': currentToken,
        }
    })
    if (typeof callbacks === "function") {
        //callbacks(data);
        if (res.status == 200) {
            callbacks({
                success: true,
                data: await res.json()
            })
        } else {
            callbacks({
                success: false,
                error: await res.json()
            });
        }
    }
}

export default getNotificationCheckbox;


